import { env } from 'config/env';

/**
 * Tenant detection.
 *
 * In production this checks window.location.origin for "cph".
 * In development you can override it by setting REACT_APP_TENANT=cph in .env
 */
export const isCphTenant =
    window.location.origin.includes('cph') || env.tenant === 'cph';
